<template>
  <el-dialog
    title="创建比较"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
    class="dialogEdit"
  >
    <el-form :model="form" label-width="80px">
      <el-form-item label="來源名稱">
          <el-input v-model="form.name" autocomplete="off">
            <template slot="prepend">繁</template>
          </el-input>
          
          <el-input v-model="form.name_cn" autocomplete="off">
            <template slot="prepend">簡</template>
          </el-input>

          <el-input v-model="form.name_en" autocomplete="off">
            <template slot="prepend">英</template>
          </el-input>
      </el-form-item>
      <el-form-item label="來源數值">
        <el-input v-model="form.value" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="縮略圖" prop="logo">
        <ipo3-upload @success="onSuccess" ref="upload" :images="files"></ipo3-upload>
      </el-form-item>
      <el-form-item label="是否顯示">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onSubmit">確 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "compare_dialog",
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: 30,
      form: {
        name: "",
        name_cn: "",
        name_en: "",
        logo: "",
        status: true
      }
    };
  },

  computed: {
    files() {
        console.log("logo:",this.form.logo);
        if(this.form.logo.length>0)
        {
            return [{url:this.form.logo,name:'logo.jpg'}];
        }else
        {
            return [];
        }
    }
  },
  methods: {
    show(value) {
      this.dialogVisible = true;
      var self = this;
      if (value !== undefined) {
        this.form = Object.assign({}, value);
        this.form.status = this.form.status == 1 ? true : false;
      } else {
        this.form = { name: "", name_cn: "", name_en: "", status: true, logo: "",value:"" };
      }
    },

    onSuccess(image) {
      this.form.logo = image.path;
    },
    onSubmit() {
      var self = this;
      let params = Object.assign({}, this.form);
      this.$http.post("/admin/source/edit", params).then(res => {
        self.$emit("sucess");
        this.dialogVisible = false;
      });
    }
  }
};
</script>
<style lang="less">
.dialogEdit {
  text-align: left;
}
</style>